import { Element } from 'react-scroll'

import Header from './components/header/Header'
import Footer from './components/footer/Footer'

import Home from './pages/home/Home'
import About from './pages/about/About'
import Work from './pages/work/Work'

const App = () => {
  return (
    <>
      <Header />

      <main className="app-container">
        <Element name="top">
          <Home />
        </Element>
        <Element className="dark-bg" name="about">
          <About />
        </Element>
        <Element name="work">
          <Work />
        </Element>
      </main>

      <Footer />
    </>
  )
}

export default App
